import React from "react";
import "./FoodBodyFatDatabase.css";

export default function FoodBodyFatDatabase() {
  const foodData = [
    {
      name: "Apple",
      role: "High Fiber, Low-Calorie",
      benefits: "Supports fat loss by promoting satiety.",
      calories: 52,
      protein: "0.3g",
      fat: "0.2g",
      carbs: "14g",
    },
    {
      name: "Chicken Breast",
      role: "High Protein",
      benefits: "Supports muscle retention during fat loss.",
      calories: 165,
      protein: "31g",
      fat: "3.6g",
      carbs: "0g",
    },
    {
      name: "Salmon",
      role: "Healthy Fats",
      benefits: "Provides omega-3 fatty acids, supports fat metabolism.",
      calories: 206,
      protein: "22g",
      fat: "13g",
      carbs: "0g",
    },
    {
      name: "Broccoli",
      role: "Low-Calorie, Nutrient-Dense",
      benefits: "Rich in fiber and micronutrients for fat metabolism.",
      calories: 55,
      protein: "3.7g",
      fat: "0.6g",
      carbs: "11.2g",
    },
    {
      name: "Almonds",
      role: "Healthy Fats",
      benefits: "Rich in unsaturated fats, promotes satiety.",
      calories: 579,
      protein: "21g",
      fat: "49g",
      carbs: "22g",
    },
    {
      name: "Sweet Potato",
      role: "Complex Carbs",
      benefits: "Provides sustained energy, reducing cravings.",
      calories: 86,
      protein: "1.6g",
      fat: "0.1g",
      carbs: "20g",
    },
    {
      name: "Egg",
      role: "High Protein",
      benefits: "Rich in amino acids, supports muscle maintenance.",
      calories: 68,
      protein: "6g",
      fat: "5g",
      carbs: "0.6g",
    },
    {
      name: "Tofu",
      role: "Plant-Based Protein",
      benefits: "Low calorie, high protein option for vegetarians.",
      calories: 144,
      protein: "15.7g",
      fat: "8g",
      carbs: "3.9g",
    },
    {
      name: "Greek Yogurt",
      role: "High Protein",
      benefits: "Promotes gut health and supports muscle growth.",
      calories: 59,
      protein: "10g",
      fat: "0.4g",
      carbs: "3.6g",
    },
    {
      name: "Spinach",
      role: "Nutrient-Dense, Low-Calorie",
      benefits: "Rich in iron and fiber, aids fat metabolism.",
      calories: 23,
      protein: "2.9g",
      fat: "0.4g",
      carbs: "3.6g",
    },
  ];

  return (
    <div className="food-calorie-database">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Food</th>
              <th>Role</th>
              <th>Benefits</th>
              <th>Calories (kcal)</th>
              <th>Protein</th>
              <th>Fat</th>
              <th>Carbohydrates</th>
            </tr>
          </thead>
          <tbody>
            {foodData.map((food, index) => (
              <tr key={index}>
                <td>{food.name}</td>
                <td>{food.role}</td>
                <td>{food.benefits}</td>
                <td>{food.calories}</td>
                <td>{food.protein}</td>
                <td>{food.fat}</td>
                <td>{food.carbs}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
